<template>
  <div>
    <el-row :gutter="10">
      <el-col :xs="12" :sm="12" :md="7" :lg="7" :xl="7">
        <el-input placeholder="Número de documento" v-model="searchInput" clearable size="medium"
          @clear="searchInput = null; getAllAction()">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </el-col>
      <el-col :xs="12" :sm="12" :md="5" :lg="5" :xl="5">
        <el-button type="primary" icon="el-icon-search" size="medium" :loading="loading" @click="getAllAction()">
          Buscar
        </el-button>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="flex-btn">
        <el-button type="success" icon="el-icon-plus" size="medium" @click="addThird">
          Nuevo
        </el-button>
        <!-- <el-button type="warning" icon="el-icon-download" size="medium" @click="modalOpen = true" class="btn-download">
          Descargar
        </el-button> -->
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-table :data="all" v-loading="loading" height="530">
          <el-empty slot="empty" description="No hay datos"></el-empty>
          <el-table-column label="Documento" prop="document" sortable></el-table-column>
          <el-table-column label="Nombre" prop="name" sortable></el-table-column>
          <el-table-column label="Telefono" prop="phone" sortable></el-table-column>
          <el-table-column label="Tipo" width="250px">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.client == 1" size="small" type="success" style="margin-right: 5px">
                Cliente
              </el-tag>
              <el-tag v-if="scope.row.seller == 1" size="small" type="warning" style="margin-right: 5px">
                Vendedor
              </el-tag>
              <el-tag v-if="scope.row.provider == 1" size="small">
                Proveedor
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Situación fiscal">
            <template slot-scope="scope">
              <el-link type="primary" class="viewDocument" @click="downloadDocument(scope.row)"
                v-if="scope.row.file_tax_situation"><i class="el-icon-download"></i> Descargar</el-link>
              <el-link disabled v-else><i class="el-icon-document-delete"></i> No hay archivo</el-link>
            </template>
          </el-table-column>
          <el-table-column width="100px" align="right">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"
                  circle></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                <el-button v-can="['admin']" :disabled="scope.row.used != 0" size="mini" type="danger"
                  @click="handleDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <div v-if="all.length > 0" class="pagination-box animated fadeInRight"
          style="text-align: end; padding-top: 10px">
          <el-pagination layout="total, prev, pager, next" :page-size="pageSize" :total="totalRows"
            @current-change="handleCurrentPage"></el-pagination>
        </div>
      </el-col>
    </el-row>

    <!-- <el-dialog title="Situación fiscal" :visible.sync="showDocument" width="80%" top="10px" center>
      <div class="content-view"> -->
        <!-- <iframe :src="urlIframe" style="width:100%; height:470px;" frameborder="0"></iframe> -->

        <!-- <PDFViewer :source="viewUrl" style="height: 70vh;" @download="downloadDocument"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDocument = false"><i class="el-icon-close"></i> Cerrar</el-button>
        <el-button type="primary" @click="downloadDocument"><i class="el-icon-download"></i> Descargar</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
// import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
import { mapGetters, mapMutations, mapActions } from "vuex";
import { downloadDocument, deletePerson } from "@/api/person";
export default {
  components: {
    // PDFViewer,
  },
  data() {
    return {
      baseUrlApi: process.env.VUE_APP_ROOT_API,
      baseUrl: process.env.VUE_APP_ROOT,
      showDocument: false,
      urlIframe: "https://docs.google.com/gview?url=",
      embedded: "&embedded=true",
      viewUrl: '',
      dataView: null
    };
  },
  created() {
    this.getAllAction()
  },
  computed: {
    ...mapGetters('third', ['all', 'search', 'loading', 'totalRows', 'pageSize']),
    searchInput: {
      get() { return this.search },
      set(value) { this['third/SET_SEARCH'](value) }
    },
  },
  methods: {
    ...mapMutations(['setRightMenu', 'third/SET_SEARCH']),
    ...mapActions('third', ['getAllAction', 'deleteAction']),
    addThird() {
      this.setRightMenu({
        componentActive: 'third-form-component',
        drawer: true,
        data: {
          icon: 'account',
          title: 'Agregar tercero',
          btnRemove: false,
          field_id: null,
          hidden_btn: true,
          edit: false,
        }
      })
    },
    handleCurrentPage(val) {
      this.getAllAction(val);
    },
    handleEdit(index, row) {
      this.setRightMenu({
        componentActive: 'third-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Editar producto',
          btnRemove: false,
          field_id: row.id,
          hidden_btn: true,
          edit: true,
        }
      })
    },
    viewDocument(row) {
      console.log(row);
      this.dataView = row
      this.showDocument = true
      // this.viewUrl = this.baseUrl + 'public/files/thirds/' + row.file_tax_situation
      this.viewUrl = 'http://localhost:8000/files/thirds/_1670428075.pdf'
      // this.urlIframe = this.urlIframe + this.viewUrl + this.embedded
      this.urlIframe = this.urlIframe + 'https://southerngeo.2inventario.com/files/thirds/_1670357946.pdf' + this.embedded
      // this.urlIframe += this.baseUrl + this.embedded
      console.log(this.viewUrl);
    },
    downloadDocument(row) {
      downloadDocument(row.id)
        .then(({ data }) => {
          this.downloadFile(data, "Situación fiscal - " + row.name);
        })
        .catch(function (error) {
          console.log(error);
          this.$message({
            type: "error",
            message: "Error! ",
          });
        });
    },
    downloadFile(response, filename) {
      this.resetField = false;
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([response], { type: "application/pdf" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename + ".pdf";
      link.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    handleDelete(index, row) {
      deletePerson({ id: row.id })
        .then(({ data }) => {
          if (data.code === 200) {
            this.$message({
              type: "success",
              message: data.message,
            });
            this.getAllAction();
          } else {
            this.$message({
              type: "error",
              message: data.message,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          this.$message({
            type: "error",
            message: "Error! ",
          });
        });
    }
  }
}
</script>

<style lang="css" scoped>
.viewDocument {
  /* font-size: 17px; */
}

.flex-btn {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

@media (max-width: 1000px) {
  .flex-btn {
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 10px;

  }

  .btn-download {
    margin-left: 0px !important;
  }
}
</style>